import React from 'react'
import {
	Input,
	Button
} from 'reactstrap'
import Reflux from 'reflux'
import axios from 'axios'

import QuantitiesStore from '~/stores/quantities'
import IngredientsStore from '~/stores/ingredients'
import IngredientsTypesStore from '~/stores/ingredientsTypes'
import CurrentRecipeStore from '~/stores/currentRecipe.js'
import CurrentRecipeActions from '~/actions/currentRecipe.js'

import ModalConfirm from '~/modules/_shared/modalConfirm.jsx'
import SimpleSelect from '~/modules/_core/simpleSelect.jsx'

import apiUtils from '../../helper/api.js'


export default class RecipeIngredientsEditRow extends Reflux.Component {
	constructor(props) {
		super(props)

		this.state = {
			showDeleteConfirm: false,
			isEditing: false,
			amount: props.amount,
			quantityID: props.quantityID,
			ingredientID: props.ingredientID,
			ingredientTypeID: props.ingredientTypeID
		}

		this.stores = [QuantitiesStore, IngredientsStore, IngredientsTypesStore, CurrentRecipeStore]
		this.storeKeys = [
			'recipeIngredients',
			'recipeIngredientID',
			'quantities',
			'ingredients',
			'ingredientsTypes'
		]

		this.toggleEdit = this.toggleEdit.bind(this)
		this.toggleDeleteConfirm = this.toggleDeleteConfirm.bind(this)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	toggleDeleteConfirm() {
		this.setState({ showDeleteConfirm: !this.state.showDeleteConfirm })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	toggleEdit() {
		this.setState({ isEditing: !this.state.isEditing })
	}


	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	handleChangeField = (event) => {
		this.setState({ [event.target.name]: event.target.value })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	saveEdit = () => {
		const formData = {
			recipeIngredientID: this.props.recipeIngredientID,
			recipeID: this.props.recipeID,
			amount: this.state.amount,
			quantityID: parseInt(this.state.quantityID, 10),
			ingredientID: parseInt(this.state.ingredientID, 10),
			ingredientTypeID: parseInt(this.state.ingredientTypeID, 10)
		}

		axios.put(`${apiUtils.getApiURL()}/recipeIngredients`, formData)
			.then(
				() => {
					this.setState({
						isEditing: false
					})
					CurrentRecipeActions.getRecipeIngredients()
				}
			)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		return (
			<tr>
				{
					this.state.isEditing === false &&

					<React.Fragment>
						<td className="text-right">{this.props.amount}</td>
						<td className="text-right">{this.props.quantityName}</td>
						<td>{this.props.ingredientName}</td>
						<td>{this.props.ingredientTypeName}</td>
						<td>
							<Button
								block
								size="sm"
								color="primary"
								onClick={this.toggleEdit}
							>
								Edit
							</Button>
						</td>
						<td>
							<Button
								block
								outline
								size="sm"
								onClick={this.toggleDeleteConfirm}
								color="warning"
							>
								Delete
							</Button>

							{
								this.state.showDeleteConfirm === true &&

								<ModalConfirm
									show={this.state.showDeleteConfirm}
									message={`Are you sure you want to remove the ingredient "${this.props.amount} ${this.props.quantityName} ${this.props.ingredientName}"?`}
									handleConfirm={
										() => {
											CurrentRecipeActions.deleteRecipeIngredients(
												this.props.recipeIngredientID,
												this.toggleDeleteConfirm
											)
										}
									}
									handleCancel={this.toggleDeleteConfirm}
								/>
							}
						</td>
					</React.Fragment>
				}

				{
					this.state.isEditing === true &&

					<React.Fragment>
						<td>
							<Input
								name="amount"
								value={this.state.amount}
								onChange={this.handleChangeField}
								style={{ textAlign: 'right' }}
							/>
						</td>
						<td>
							<SimpleSelect
								onChange={this.handleChangeField}
								name="quantityID"
								value={this.state.quantityID}
								options={this.state.quantities}
								itemKeyValue="quantityID"
								itemKeyLabel="quantity"
							/>
						</td>
						<td>
							<SimpleSelect
								onChange={this.handleChangeField}
								name="ingredientID"
								value={this.state.ingredientID}
								options={this.state.ingredients}
								itemKeyValue="ingredientID"
								itemKeyLabel="ingredient"
							/>
						</td>
						<td>
							<SimpleSelect
								onChange={this.handleChangeField}
								name="ingredientTypeID"
								value={this.state.ingredientTypeID}
								options={this.state.ingredientsTypes}
								itemKeyValue="ingredientTypeID"
								itemKeyLabel="ingredientType"
							/>
						</td>
						<td>
							<Button
								color="primary"
								size="sm"
								block
								onClick={this.saveEdit}
							>
								Save
							</Button>
						</td>
						<td>
							<Button
								onClick={this.toggleEdit}
								color="secondary"
								size="sm"
								block
							>
								Cancel
							</Button>
						</td>
					</React.Fragment>
				}
			</tr>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipeIngredients/editRow.jsx